import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Dialog, DialogContent, Grid } from "@mui/material";

function LoadingComponent(props) {
    const { showLoading } = props;
    return (
        <Dialog open={showLoading} sx={{
        }}>
            <DialogContent sx={{ }}>
                <Grid item container justifyContent={'center'}>
                    <CircularProgress size={'2rem'}/>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

LoadingComponent.propTypes = {
    showLoading: PropTypes.bool,
}

export default LoadingComponent;